import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Button, TextField } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import authStore from "../../stores/AuthStore";
import { useState } from "react";
import feedbackStore from "../../stores/FeedbackStore";
import { FeedbackSeverity } from "../../stores/FeedbackStore/types";

interface VerifyEmailDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  email: string;
  onVerified: () => void;
}

const VerifyEmailDialog = ({
  isOpen,
  setIsOpen,
  email,
  onVerified,
}: VerifyEmailDialogProps) => {
  const { t } = useTranslation();
  const [code, setCode] = useState("");

  const handleVerify = () => {
    authStore
      .validateEmailCode(code, email)
      .then(() => onVerified())
      .catch(() => {
        feedbackStore.setShowFeedback(true, {
          message: "verificationFailed",
          severity: FeedbackSeverity.ERROR,
        });
      });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="adminCaseItemDialog"
    >
      <DialogActions className="dialogActions">
        <Button onClick={() => setIsOpen(false)} color={"error"}>
          &times;
        </Button>
      </DialogActions>
      <DialogContent className={"pt pr pl pb"}>
        <h5>{t("enterVerificationCode")}</h5>
        <main>
          <TextField
            type="number"
            fullWidth
            placeholder={"_ _ _ _ _ _"}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setCode(e.target.value)
            }
          />
        </main>
        <footer className={"pt"}>
          <Button
            variant={"contained"}
            fullWidth
            className={"mt"}
            onClick={handleVerify}
          >
            {t("submit")}
          </Button>
        </footer>
      </DialogContent>
    </Dialog>
  );
};

export default VerifyEmailDialog;
